import React from 'react';

const OvalIcon = (): JSX.Element => (
  <svg width="4" height="4" viewBox="0 0 4 4" xmlns="http://www.w3.org/2000/svg">
    <circle cx="1279" cy="874" r="2" transform="translate(-1277 -872)" fill="#C8C8C8" fillRule="evenodd" />
  </svg>
);

export default OvalIcon;
